import io from 'socket.io-client';

var socket = {};

export function initialize(address) {

    if (address.path) {
        socket = io(address.host, {
            path: address.path
        });
    }
    else {
        socket = io(address.host);
    }
}

export function getInstance() {
    return socket;
}